import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('rpb_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.getMe();
      setUser(res.user);
    } catch {
      localStorage.removeItem('rpb_token');
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('rpb_token', res.token);
    setUser(res.user);
    toast.success(`🙏 जय श्री राम! Welcome, ${res.user.name}`);
    return res;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem('rpb_token', res.token);
    setUser(res.user);
    toast.success(`✨ खाता बनाया! Welcome, ${res.user.name}`);
    return res;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {}
    localStorage.removeItem('rpb_token');
    setUser(null);
    toast.info('👋 Logged out successfully');
  };

  const updateProfile = async (data) => {
    const res = await authAPI.updateProfile(data);
    setUser(res.user);
    toast.success('✅ Profile updated');
    return res;
  };

  const toggleWishlist = async (productId) => {
    const res = await authAPI.toggleWishlist(productId);
    setUser(u => ({ ...u, wishlist: res.wishlist }));
    return res;
  };

  const refreshUser = () => loadUser();

  return (
    <AuthContext.Provider value={{ user, loading, isAuthenticated: !!user, login, register, logout, updateProfile, toggleWishlist, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
